import React from "react";
import Layout from '../components/layout'
import { graphql, Link } from "gatsby"
import Helmet from 'react-helmet'
import Footer from '../components/Footer'

class BlogPostTemplate extends React.Component {
  render(){
    const post = this.props.data.blog;
    
    return (
      <Layout pageType="blogPost" location={this.props.location}>
        <Helmet title={`${post.title} | Creative Portrait Photographer | Clair Estelle`} /> 
        <main>
          <div className="blog-wrapper">
            <div className="blog-content">
              <div className="blog-left">
                <div><img src={post.leadImageUrl} alt={post.leadImageAltText} /></div>
                <div dangerouslySetInnerHTML={{ __html: post.content }} />
                <p class="tags">
                <ul>
                  {
                    post.tags.map( tag => {
                      return  <li><Link to={`/tags/${tag.slug}`}>{tag.title}</Link></li>;
                    })
                  }
                </ul>
                </p>
                
              </div>
              <div className="blog-right">
                <Link to={`/blog/${post.slug}`}><h2>{post.title}</h2></Link>
                <div dangerouslySetInnerHTML={{ __html: post.sideBarContent }} />
              </div>
            </div>
          </div>
          <div className="blog-footer">
              <Footer />
            </div>
        </main>
      </Layout>
    );
  }
}

export default BlogPostTemplate
  
export const query = graphql`
  query($slug: String!) {
    blog(slug: { eq: $slug }) {
      title,
      leadImageUrl,
      leadImageAltText,
      content,
      sideBarContent,
      slug,
      tags {
        title,
        slug
      }
    }
  }
`;